import React, { useCallback } from "react";
import useHistory from "routing/useHistory";
import { ButtonGroup, DropdownButton, MenuItem } from "components/bootstrap";
import Routes from "routing/Routes";
import useHasTypeMappingPermission from "hooks/useHasTypeMappingPermission";
const IndicesConfigurationDropdown = ({ indexSetId }) => {
  const hasMappingPermission = useHasTypeMappingPermission();
  const history = useHistory();
  const onShowFieldTypes = useCallback(() => {
    history.push(Routes.SYSTEM.INDEX_SETS.FIELD_TYPES(indexSetId));
  }, [history, indexSetId]);
  if (!hasMappingPermission) return null;
  return /* @__PURE__ */ React.createElement(ButtonGroup, null, /* @__PURE__ */ React.createElement(DropdownButton, { bsStyle: "info", title: "Configuration", id: "indices-configuration-actions", pullRight: true }, hasMappingPermission && /* @__PURE__ */ React.createElement(MenuItem, { onClick: onShowFieldTypes }, "Configure index field types")));
};
export default IndicesConfigurationDropdown;
